// Components.
import List from '@/components/pronto-atendimento/fila/List'
import ModalEvasao from '@/components/pronto-atendimento/fila/components/evasao/Modal'

// Enums.
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'
import statusTipo from '@/enums/painel-senha/statusTipo'

import { error, repository } from '@/mixins'
import { mapActions } from 'vuex'

export default {
    components: { List, ModalEvasao },
    computed: {
        fields() {
            if (this.model.statusTipoId === this.enums.statusTipo.EM_ATENDIMENTO) {
                return [
                    { key: 'opcaoEntrada.nome', label: 'Opção de Entrada' },
                    { key: 'senha', label: 'Senha' },
                    { key: 'prioridade', label: 'Prioridade' },
                    { key: 'atendimento.recepcao.atendidoEm', label: 'Data do Atendimento' },
                    { key: 'atendimento.paciente.cidadao.prontuario', label: 'Prontuário' },
                    { key: 'nome', label: 'Nome' },
                    { key: 'Idade', label: 'Idade' },
                    { key: 'atendimento.recepcao.ocupacao.nome', label: 'Especialidade Médica' },
                    { key: 'atendimento.profissionalAtual.nome', label: 'Profissional' },
                    { key: 'actions', label: 'Ações', class: 'col-min text-center' },
                ]
            } else {
                return [
                    { key: 'tempoEspera', label: 'Tempo de espera', class: 'col-min' },
                    { key: 'opcaoEntrada.nome', label: 'Opção de Entrada' },
                    { key: 'senha', label: 'Senha' },
                    { key: 'prioridade', label: 'Prioridade' },
                    { key: 'atendimento.recepcao.atendidoEm', label: 'Data do Atendimento' },
                    { key: 'atendimento.paciente.cidadao.prontuario', label: 'Prontuário' },
                    { key: 'nome', label: 'Nome' },
                    { key: 'Idade', label: 'Idade' },
                    { key: 'atendimento.recepcao.ocupacao.nome', label: 'Especialidade Médica' },
                    { key: 'actions', label: 'Ações', class: 'col-min text-center' },
                ]
            }
        },
    },
    created() {

        this.repositories = {
            fila: this.getConectaSusRepository('prontoAtendimento.fila')
        }
    },
    data: () => ({
        enums: { setorTipo, statusTipo },
        model: {
            statusTipoId: null,
            currentPlantaoId: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        answer(item) {

            if (item.status.tipo.id === this.enums.statusTipo.EM_ESPERA) {

                this.setLoading()

                this.repositories.fila.answer(item.id)
                    .then(() => this.redirectToCreate(item))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

                return
            }

            this.redirectToCreate(item)
        },
        redirectToCreate(item) {

            this.$router.push({
                name: this.createRouteName,
                params: { id: item.id, plantaoId: this.model.currentPlantaoId }
            })
        },
        handleStatusTipoChanged(id) {
            this.model.statusTipoId = id
        },
        async getImpressoes(atendimentoId, setorTipoId) {

            let impressoes = {}

            this.setLoading()

            try {

                impressoes = (await this.repositories.fila.getImpressoes(atendimentoId, setorTipoId)).data
            }
            catch (error) {

                this.handleError(error)
            }
            finally {

                this.unsetLoading()
            }

            return impressoes
        },
        async getAdditionalEnfermagemData(atendimentoId) {

            let data = {}

            this.setLoading()

            try {

                data = (await this.repositories.fila.getAdditionalEnfermagemData(atendimentoId)).data
            }
            catch (error) {

                this.handleError(error)
            }
            finally {

                this.unsetLoading()
            }

            return data
        },
    },
    mixins: [error, repository]
}